var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGenerator1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.04386 3.76881C8.08199 3.7895 8.11818 3.81521 8.15151 3.84599L8.55511 4.21881L8.695 3.63377C10.1023 3.97028 11.2022 5.01901 11.6401 6.3475L14.1713 3.60732C14.3708 3.39129 14.7077 3.37793 14.9237 3.57748C15.1398 3.77703 15.1531 4.11392 14.9536 4.32995L11.7017 7.85032C11.685 7.86836 11.6674 7.88499 11.649 7.9002C11.6283 7.99348 11.5823 8.08235 11.5108 8.15587L11.2873 8.38576L11.7577 8.48418C11.4441 9.98263 10.331 11.1526 8.92026 11.5787L11.5948 14.1798C11.8056 14.3848 11.8103 14.7219 11.6053 14.9328C11.4003 15.1436 11.0631 15.1483 10.8523 14.9432L7.41664 11.602C7.38463 11.5709 7.35737 11.5367 7.33487 11.5004C7.29369 11.4778 7.25485 11.4493 7.21955 11.415L6.91365 11.1173L6.79002 11.6434C5.33931 11.3025 4.2127 10.2054 3.79707 8.82372L1.19562 11.497C0.990516 11.7077 0.65339 11.7123 0.442627 11.5072C0.231864 11.3021 0.227276 10.965 0.432378 10.7542L3.77472 7.31964C3.82862 7.26425 3.89164 7.2231 3.95909 7.19626L4.23476 6.89871L3.71172 6.78927C4.01821 5.32447 5.08867 4.1737 6.45436 3.72461L3.71749 1.18896C3.50176 0.989085 3.4889 0.652173 3.68877 0.436443C3.88865 0.220712 4.22556 0.207855 4.44129 0.407725L7.95682 3.66481C7.99091 3.69639 8.01994 3.7314 8.04386 3.76881ZM4.93704 7.70773L7.6235 4.80808L10.6038 7.56103L7.77514 10.4696L4.93704 7.70773Z",
    fill: "#73A8AE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerator1);
export default __webpack_public_path__ + "static/media/generator1.eb884bb14c1700ad3d7602876ec91fea.svg";
export { ForwardRef as ReactComponent };